var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user_not_found"},[_vm._v(" "+_vm._s(_vm.$t('error.userNotFound'))+" "),_c('a',{on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm.$t('error.portal'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }